import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../style/login.css";
import { FaEye, FaEyeSlash, FaDownload } from "react-icons/fa";
import BackgroundImage from "../assets/waterbg.jpg";
import { AuthContext } from "../context/AuthContext";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    if (!username || !password) {
      alert("Please enter username and password.");
      return;
    }

    setSubmitting(true);
    const result = await login(username, password);
    setSubmitting(false);

    if (result.success) {
      if (result.role === "ADMIN") {
        navigate("/admin", { state: { username } });
      } else if (result.role === "EXECUTIVE") {
        navigate("/executive", { state: { username } });
      } else {
        navigate("/home", { state: { username } });
      }
    } else {
      alert(result.message || "Invalid credentials. Please try again.");
    }
  };

  // PWA Install
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the PWA install prompt");
        } else {
          console.log("User dismissed the PWA install prompt");
        }
        setDeferredPrompt(null);
        setIsInstallable(false);
      });
    }
  };

  return (
    <div className="container" style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className="sidebar"></div>
      <div className="login-box">
        {isInstallable && (
          <button
            id="install-button"
            onClick={handleInstall}
            className="login-btn"
            style={{ padding: "12px 5px", width: "150px", background: "green" }}
          >
            <FaDownload /> Install PWA
          </button>
        )}
        <h2>Water Meter Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Enter Username"
            className="inputs-box"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="inputs-box"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="button" className="icon-btn" onClick={togglePassword}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button type="submit" className="login-btn" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <p className="footer-text">powered by @Dexpert Systems</p>
      </div>
    </div>
  );
}

export default Login;
